// src/components/ExampleGraph/ExampleGraph.js
import React, { useRef, useEffect } from "react";
import ForceGraph3D from "react-force-graph-3d";

const ExampleGraph = () => {
  const fgRef = useRef();

  // demo dataset
  const N = 20;
const graphData = {
  nodes: [...Array(N).keys()].map(i => ({ id: i, name: `Node ${i}` })),
  links: [...Array(N * 2).keys()].map(() => ({
    source: Math.floor(Math.random() * N),
    target: Math.floor(Math.random() * N)
  }))
};

  useEffect(() => {
    if (fgRef.current) {
      // 👇 set a closer camera distance
      fgRef.current.cameraPosition(
        { x: 0, y: 0, z: 200 }, // position
        { x: 0, y: 0, z: 0 },   // look-at
        2000                    // transition ms
      );
    }
  }, []);

  return (
    <ForceGraph3D
      ref={fgRef}
      graphData={graphData}
      width={500}
      height={400}
      backgroundColor="#ffffff"
      nodeAutoColorBy="id"
      nodeLabel="name"
      linkDirectionalArrowLength={3.5}
      linkColor={() => "#aaa"}
      enableNodeDrag={true}
      showNavInfo={false}
    />
  );
};

export default ExampleGraph;
